/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, ContentChildren, Component, Directive, EventEmitter, forwardRef, Input, Optional, Output, ViewChild, } from '@angular/core';
import { provideValueAccessor, TemplateUuids } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
const _c0 = ["input"];
const _c1 = ["*"];
/**
 * @deprecated since version 9.0
 */
export class RadioGroupDirective {
    constructor(_changeDetector) {
        this._changeDetector = _changeDetector;
        this.templateUuids = new TemplateUuids();
        this._required = false;
        this._disabled = false;
        this._selected = null;
        this._value = null;
        this.radioGroupChange = new EventEmitter();
        this.onChangeCallback = (_) => { };
        this.onTouchedCallback = () => { };
    }
    set required(value) {
        this._required = typeof value !== 'undefined' && value !== false;
    }
    get required() {
        var _a;
        if (this._required) {
            return true;
        }
        let isRequired = false;
        (_a = this.radioButtons) === null || _a === void 0 ? void 0 : _a.forEach((radio, index) => {
            if (radio._required) {
                isRequired = true;
            }
        });
        return isRequired;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = !!value;
        this._markRadiosForCheck();
    }
    get selected() {
        return this._selected;
    }
    set selected(selected) {
        this._selected = selected;
        this.value = selected ? selected.value : null;
        this._checkSelectedRadioButton();
    }
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (this._value !== newValue) {
            // Set this before proceeding to ensure no circular loop occurs with selection.
            this._value = newValue;
            this._updateSelectedRadioFromValue();
            this._checkSelectedRadioButton();
        }
    }
    ngAfterContentInit() {
        const uuid = this.templateUuids.get('radioName');
        this.radioButtons.forEach((radio, index) => {
            radio._inputElement.nativeElement.name = uuid;
        });
        this._changeDetector.detectChanges();
    }
    change(radioButton) {
        this.radioGroupChange.emit(radioButton);
    }
    _checkSelectedRadioButton() {
        if (this._selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    }
    _markRadiosForCheck() {
        if (this.radioButtons) {
            this.radioButtons.forEach((radio) => radio._markForCheck());
        }
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this._changeDetector.markForCheck();
    }
    _updateSelectedRadioFromValue() {
        // If the value already matches the selected radio, do nothing.
        const isAlreadySelected = this._selected != null && this._selected.value === this._value;
        if (this.radioButtons != null && !isAlreadySelected) {
            this._selected = null;
            this.radioButtons.forEach((radio) => {
                radio.checked = this.value === radio.value;
                if (radio.checked) {
                    this._selected = radio;
                }
            });
        }
    }
    writeValue(val) {
        if (val !== this.value) {
            this.value = val;
        }
    }
}
RadioGroupDirective.ɵfac = function RadioGroupDirective_Factory(t) { return new (t || RadioGroupDirective)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
RadioGroupDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: RadioGroupDirective, selectors: [["", "mheRadioGroup", ""]], contentQueries: function RadioGroupDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, RadioButtonComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.radioButtons = _t);
    } }, inputs: { required: "required", disabled: "disabled", selected: "selected", value: "value" }, outputs: { radioGroupChange: "radioGroupChange" }, exportAs: ["mheRadioGroup"], features: [i0.ɵɵProvidersFeature([provideValueAccessor(RadioGroupDirective)])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioGroupDirective, [{
        type: Directive,
        args: [{
                selector: '[mheRadioGroup]',
                exportAs: 'mheRadioGroup',
                providers: [provideValueAccessor(RadioGroupDirective)],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { required: [{
            type: Input
        }], disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], value: [{
            type: Input
        }], radioGroupChange: [{
            type: Output
        }], radioButtons: [{
            type: ContentChildren,
            args: [forwardRef(() => RadioButtonComponent), { descendants: true }]
        }] }); })();
/**
 * @deprecated since version 9.0
 */
export class RadioButtonComponent {
    constructor(radioGroup, _changeDetector) {
        this.radioGroup = radioGroup;
        this._changeDetector = _changeDetector;
        this._required = false;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        this._checked = false;
        this._disabled = false;
        this._value = null;
    }
    set required(value) {
        this._required = typeof value !== 'undefined' && value !== false;
    }
    get required() {
        return this._required;
    }
    get checked() {
        return this._checked;
    }
    set checked(value) {
        const newCheckedState = !!value;
        if (this._checked !== newCheckedState) {
            this._checked = newCheckedState;
            this._inputElement.nativeElement.checked = this._checked;
            if (newCheckedState && this.radioGroup && this.radioGroup.value !== this.value) {
                this.radioGroup.selected = this;
            }
            else if (!newCheckedState && this.radioGroup && this.radioGroup.value === this.value) {
                this.radioGroup.selected = null;
            }
            if (newCheckedState && this.radioGroup && this.radioGroup.radioButtons) {
                this.radioGroup.radioButtons.forEach((radioButton) => {
                    if (radioButton !== this) {
                        radioButton.checked = false;
                    }
                });
            }
            this._changeDetector.markForCheck();
        }
    }
    get disabled() {
        return this._disabled || (this.radioGroup !== null && this.radioGroup.disabled);
    }
    set disabled(value) {
        const newDisabledState = !!value;
        if (this._disabled !== newDisabledState) {
            this._disabled = newDisabledState;
            this._changeDetector.markForCheck();
        }
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            if (this.radioGroup != null) {
                if (!this.checked) {
                    this.checked = this.radioGroup.value === value;
                }
                if (this.checked) {
                    this.radioGroup.selected = this;
                }
            }
        }
    }
    inputChange(event) {
        event.stopPropagation();
        // Sync the value from the underlying input element with the component instance.
        this.checked = this._inputElement.nativeElement.checked;
        this.change.emit();
        if (this.radioGroup) {
            this.radioGroup.change(this);
        }
    }
    _markForCheck() {
        this._changeDetector.markForCheck();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this._changeDetector.markForCheck();
    }
}
RadioButtonComponent.ɵfac = function RadioButtonComponent_Factory(t) { return new (t || RadioButtonComponent)(i0.ɵɵdirectiveInject(RadioGroupDirective, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
RadioButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RadioButtonComponent, selectors: [["mhe-radio-button"]], viewQuery: function RadioButtonComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._inputElement = _t.first);
    } }, inputs: { required: "required", checked: "checked", disabled: "disabled", value: "value" }, outputs: { change: "change" }, ngContentSelectors: _c1, decls: 5, vars: 2, consts: [[1, "ahe-ui-radio"], ["type", "radio", 3, "change"], ["input", ""]], template: function RadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "label", 0)(1, "input", 1, 2);
        i0.ɵɵlistener("change", function RadioButtonComponent_Template_input_change_1_listener($event) { return ctx.inputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span");
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("disabled", ctx.disabled ? "" : null)("required", ctx.required ? "" : null);
    } }, styles: ["\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioButtonComponent, [{
        type: Component,
        args: [{ selector: 'mhe-radio-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<label class=\"ahe-ui-radio\">\n  <input\n    #input\n    type=\"radio\"\n    (change)=\"inputChange($event)\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.required]=\"required ? '' : null\"\n  />\n  <span><ng-content></ng-content></span>\n</label>\n", styles: ["/*# sourceMappingURL=radio-button.component.css.map */\n"] }]
    }], function () { return [{ type: RadioGroupDirective, decorators: [{
                type: Optional
            }] }, { type: i0.ChangeDetectorRef }]; }, { required: [{
            type: Input
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], value: [{
            type: Input
        }], change: [{
            type: Output
        }], _inputElement: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }] }); })();
